/* eslint-disable */
// import './wdyr';
import 'timing.js';
import core from '@gin-betting/core';

import BettingAPI from './root/BettingAPI';
import { isMobile } from 'app-constants';
import adaptBettingOptions from './utils/adaptBettingOptions';
import { classics, esports } from 'components/Helper/constants';
import './styles/sizes.scss';
import './global.scss';

const {
    utils: { getBettingOptions },
} = core;

window.__app = window.__app || ({} as AppPublicAPI);
window.__app.timings = {};

if (__DEV__) {
    let disabledHeader: HTMLElement | null = null;
    let enabledHeader: HTMLElement | null = null;

    if (isMobile) {
        disabledHeader = document.getElementById('header');
        enabledHeader = document.getElementById('mobile-header');
    } else {
        disabledHeader = document.getElementById('mobile-header');
        enabledHeader = document.getElementById('header');
    }

    if (disabledHeader) {
        disabledHeader.style.display = 'none';
    }

    if (enabledHeader) {
        enabledHeader.style.display = 'block';
    }
}

init();

function init() {
    // @ts-ignore
    window['bettingOptions'] = adaptBettingOptions(window['bettingOptions']);

    const bettingAPI = new BettingAPI();
    // @ts-ignore
    window['bettingAPI'] = bettingAPI;

    if (__DEV__) {
        window.bettingLoader = {
            __getLocale: require('./getLocale').default(
                getBettingOptions().locale
            ),
        } as any;
        // @ts-ignore
        window['bettingOptions'].sportIds = [...classics, ...esports];
        // bettingAPI.setupBreakpoints({
        //     medium: 900,
        // });
        // bettingAPI.setupWidget(BettingWidgets.BETSLIP_SIDEBAR, {
        //     containerElementId: 'betslip',
        //     isOpen: true,
        //     canToggle: true,
        // });
        // bettingAPI.setupWidget(BettingWidgets.CATEGORIZER, {
        //     containerElementId: 'categorizer',
        // });

        // @ts-ignore
        window['bettingAPI'].subscribe('redirect', ({ destination, link }) => {
            switch (destination) {
                case 'mix-sports':
                case 'esport':
                case 'sport':
                default: {
                    // console.log({ destination, link });
                }
            }
        });

        return bettingAPI.init();
    }

    window.bettingLoader?.__publishBettingAPI(bettingAPI);
}

// function setupSentry() {
//     const bettingOptions = getBettingOptions();

//     if (
//         !bettingOptions ||
//         __DEV__ ||
//         location.hostname.includes('stage') ||
//         location.hostname.includes('dev.') || // cv stage
//         location.hostname.includes('cv.staging') // cv stage
//     ) {
//         return;
//     }

//     const { locale, currency, token, isAuthorized, url } = bettingOptions;

//     sentryHub.setClient({
//         dsn: 'https://2c0fef52363e4a778cd5399f9ecded0f@sentry.io/297300',
//         release: __SENTRY_RELEASE__,
//         environment: 'production',
//         sampleRate: 0.1,
//         maxBreadcrumbs: 20,
//         enabled: true,
//         ignoreErrors: [
//             'top.GLOBALS',
//             'originalCreateNotification',
//             'canvas.contentDocument',
//             'fb_xd_fragment',
//             'Failed to fetch',
//             'NetworkError when attempting to fetch resource.',
//             'A batched Operation of responses for',
//             'window.dohander.getBody',
//             'window.dor.by',
//             'AbortError',
//             'player.twitch.tv',
//         ],
//         blacklistUrls: [
//             /\/(gtm|ga|analytics)\.js/i,
//             /extensions\//i,
//             /^chrome:\/\//i,
//             /mobile-build.js/i,
//             /mobile_main_user/i,
//         ],
//     });

//     sentryHub.setTags({
//         locale,
//         currency,
//         authorized: isAuthorized ? 'true' : 'false',
//         version: __VERSION__,
//     });

//     sentryHub.setExtras({
//         token,
//         pagePath: url.pagePath,
//         timings: window.__app.timings,
//     });
// }
